import { render, staticRenderFns } from "./ProductDescriptionComponent.vue?vue&type=template&id=5f58bd62&scoped=true"
import script from "./ProductDescriptionComponent.vue?vue&type=script&lang=js"
export * from "./ProductDescriptionComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductDescriptionComponent.vue?vue&type=style&index=0&id=5f58bd62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f58bd62",
  null
  
)

export default component.exports